import { render, staticRenderFns } from "./partnerManage.vue?vue&type=template&id=f408f840&scoped=true&"
import script from "./partnerManage.vue?vue&type=script&lang=js&"
export * from "./partnerManage.vue?vue&type=script&lang=js&"
import style0 from "./partnerManage.vue?vue&type=style&index=0&id=f408f840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f408f840",
  null
  
)

export default component.exports